/**
 * Handles all focus to anchor
 * @module focus to
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
// Expose the function as a jQuery plugin for ease of uses
export const PLUGIN_NAME = 'focusTo';
export const DEFAULTS = {
  updateURL: false,
};


/**
 * Prevents focus scroll
 * @param {HTMLElement} $target - element sending focus to
 */
const focusWithoutScroll = ($target) => {
  const x = $(document).scrollLeft();
  const y = $(document).scrollTop();
  $target.focus();
  window.scrollTo(x, y);
};

/**
 * Scrolls to element
 * @param {HTMLElement} $target - element sending focus to
 * @param {number} scrollPosOffset - offset number
 */
const scrollToElement = ($target, scrollPosOffset) => {
  const focusActive = $('html').hasClass('focus-active');
  if (focusActive) {
    $('html, body').stop().animate({
      scrollTop: $target.offset().top - 6,
    }, 400);
  } else {
    $('html, body').stop().animate({
      scrollTop: $target.offset().top - scrollPosOffset - 0,
    }, 400);
  }
};

/**
 * Initiates Focus / Scroll
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {object} evt - event object
 */
function focusStart(el, evt) {
  evt.preventDefault(evt);
  const headerHeight = $('.js-fixed-header').height();
  const headerIsFixed = $('.js-fixed-header').hasClass('is-fixed');
  const hash = el.hash;
  const $target = $(hash);
  let scrollPosOffset = 0;

  if (headerIsFixed) {
    scrollPosOffset = 0;
  } else {
    scrollPosOffset = headerHeight;
  }
  window.history.pushState('', '', hash);
  focusWithoutScroll($target);
  scrollToElement($target, scrollPosOffset);
}
/**
 * Handles Event Listeners.
 * @param  {jQuery} $el - button /element selector
 * @param {HTMLElement} el - button /element that opens focusTo
 */
function setEventListeners($el, el) {
  $el.on('click', (evt) => {
    focusStart(el, evt);
  });
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function focusTo(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, focusTo);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/focus-to.js